import { createGlobalStyle } from 'styled-components';
import { colors } from '@/styles/colors';

export const GlobalStyles = createGlobalStyle`
  #__next {
    margin: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  html,
  body,
  #app,
  #app>div {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -ms-overflow-style: none;
    scrollbar-width: none;

    // background dots effect.
    background-image: radial-gradient(circle, rgba(0, 0, 0, 0.2) 1px, transparent 1px);
    background-size: 15px 15px;
    background-position: 0 0;
    background-repeat: repeat;    
    background-color:${colors.offWhite};

    color: ${colors.textPrimary};
  }
`;
